import React from 'react';
import { motion } from 'framer-motion';
const partners = [{
  name: 'Airedale',
  src: 'https://cdn.magicpatterns.com/uploads/cTmWfuiQWHb5b893nPmkNL/client-airedale.svg'
}, {
  name: 'Carrier',
  src: 'https://cdn.magicpatterns.com/uploads/hz8jb2zMvjbAPC1amT9TE7/client-carrier.svg'
}, {
  name: 'Daikin',
  src: 'https://cdn.magicpatterns.com/uploads/khPQKG24aZn2r3EidJR6xg/client-daikin.svg'
}, {
  name: 'LG',
  src: 'https://cdn.magicpatterns.com/uploads/gpGMJgN8KzAfA3wdNxQ5Bh/client-lg.svg'
}, {
  name: 'Mitsubishi Electric',
  src: 'https://cdn.magicpatterns.com/uploads/3ZEbchfUpSTjfUwmpUAhN6/client-mitsubishi.svg'
}, {
  name: 'Panasonic',
  src: 'https://cdn.magicpatterns.com/uploads/pzuj4eiRxinwRLKWwdQ2Fz/client-panasonic.svg'
}, {
  name: 'Sanyo',
  src: 'https://cdn.magicpatterns.com/uploads/nBNFzGcJY1yLCWfbHp8Qe7/client-sanyo.svg'
}, {
  name: 'Toshiba',
  src: 'https://cdn.magicpatterns.com/uploads/kfauPeDiuVjvDcW7FctHsD/client-toshiba.svg'
}, {
  name: 'Trane',
  src: 'https://cdn.magicpatterns.com/uploads/jeXGztUU2dVGEaD5pjaftJ/client-trane.svg'
}, {
  name: 'BESA',
  src: 'https://cdn.magicpatterns.com/uploads/jo6rVf4k1TsuFxc8CF9hSk/acc-besa.png'
}, {
  name: 'CHAS',
  src: 'https://cdn.magicpatterns.com/uploads/2FA87CtJq3CRcUi4Xcmf5w/acc-chas.png'
}, {
  name: 'D1 Premium Partner',
  src: 'https://cdn.magicpatterns.com/uploads/mcQVnc757qyoAYN17dPUnA/acc-d1.png'
}, {
  name: 'Fujitsu Infinity Partner',
  src: 'https://cdn.magicpatterns.com/uploads/2bur7AKX4bav4Ji73hJpM7/acc-fujitsu.png'
}, {
  name: 'ISO 9001:2015',
  src: 'https://cdn.magicpatterns.com/uploads/eXZzz3xSbHUJ1wTfq3KUK3/acc-iso.png'
}, {
  name: 'Mitsubishi Electric Accredited Installer',
  src: 'https://cdn.magicpatterns.com/uploads/u4wNLmkihgfoVY6zFXiVRD/acc-mitsubishi.png'
}, {
  name: 'SafeContractor Approved',
  src: 'https://cdn.magicpatterns.com/uploads/jFm1QpjEmC16VTGoXegaaN/acc-safe.png'
}];
// Duplicate the array to create seamless loop
const duplicatedPartners = [...partners, ...partners];
export function PartnerLogos() {
  return <div className="w-full border-b border-gray-100 py-10 overflow-hidden bg-[#E8F0F8]" data-id="element-217">
      <motion.div className="flex items-center gap-16 md:gap-24 w-max" animate={{
      x: ['0%', '-50%']
    }} transition={{
      x: {
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }
    }} data-id="element-218">
        {duplicatedPartners.map((partner, index) => <img key={index} src={partner.src} alt={partner.name} className="h-12 md:h-[4.2rem] w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500 flex-shrink-0" data-id="element-219" />)}
      </motion.div>
    </div>;
}